import React, { useState, useEffect } from "react";
import { Form, Button, Card, Alert } from "react-bootstrap";

function AccountSettingsPage() {
  const [userData, setUserData] = useState({
    username: "",
    email: "",
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [message, setMessage] = useState("");

  // Fetch user data from API (Mock Example)
  useEffect(() => {
    // Simulating a backend call to fetch user data
    setUserData({ username: "johndoe", email: "johndoe@example.com" });
  }, []);

  const handleChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (userData.newPassword && userData.newPassword !== userData.confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }

    // Simulate API request to update user details
    setMessage("Profile updated successfully!");

    // Here you would make an API call, e.g.:
    // fetch("/api/update-profile", { method: "POST", body: JSON.stringify(userData) })
  };

  return (
    <Card className="p-4">
      <Card.Body>
        <h4 className="mb-3">Account Settings</h4>
        {message && <Alert variant="success">{message}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Username</Form.Label>
            <Form.Control 
              type="text" 
              name="username"
              value={userData.username}
              onChange={handleChange}
              required 
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control 
              type="email" 
              name="email"
              value={userData.email}
              onChange={handleChange}
              required 
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Current Password</Form.Label>
            <Form.Control 
              type="password" 
              name="currentPassword"
              onChange={handleChange} 
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>New Password</Form.Label>
            <Form.Control 
              type="password" 
              name="newPassword"
              onChange={handleChange} 
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Confirm New Password</Form.Label>
            <Form.Control 
              type="password" 
              name="confirmPassword"
              onChange={handleChange} 
            />
          </Form.Group>

          <Button variant="primary" type="submit">Update Profile</Button>
        </Form>
      </Card.Body>
    </Card>
  );
}

export default AccountSettingsPage;
